import { AlertBox } from 'shared/ui/AlertBox';
import { getKeys } from 'shared/lib/object';
import type { CampaignTypeKey } from 'entities/campaign';
import { CampaignTypesTable } from 'entities/campaign';
import type { ServiceType } from 'entities/service';

interface StepTypeAlertBoxProps {
  service: ServiceType;
  isImpersonate: boolean;
  isSalesCardDisabled: boolean;
}

const campaignTypeIconMaps: Record<CampaignTypeKey, string> = {
  appt: 'event_available',
  lead: 'group',
  sales: 'paid',
};

const alertBoxStyle = {
  className: 'mt-6 border-deep-blue-100 text-slate-700',
  iconClass: 'text-deep-blue-500',
};

export function StepTypeAlertBox({ service, isImpersonate, isSalesCardDisabled }: StepTypeAlertBoxProps) {
  const disabledCampaignTypes = getKeys(CampaignTypesTable)
    .filter((item) => !service.campaignTypes.includes(item))
    .filter((type) => !(type === 'sales' && !isImpersonate));

  return (
    <>
      {!!disabledCampaignTypes.length && (
        <AlertBox
          {...alertBoxStyle}
          iconName={disabledCampaignTypes.length === 1 ? campaignTypeIconMaps[disabledCampaignTypes[0]] : 'info'}
        >
          {disabledCampaignTypes.map((type) => CampaignTypesTable[type]).join(' and ')}{' '}
          {disabledCampaignTypes.length === 1 ? 'is' : 'are'} not available for {service.name} at this time.
        </AlertBox>
      )}
      {isImpersonate && isSalesCardDisabled && (
        <AlertBox
          {...alertBoxStyle}
          iconName="paid"
        >
          Sales is not available for Credit Card payment method at this time.
        </AlertBox>
      )}
    </>
  );
}
